import { msg as swalMsg } from "../swal_msg";
import { protectedFetchReq } from "../../helpers/requestHelper";

// lista de carritos abandonados
export const abandonedCartList = async (
    filters, setCart, setPagination, setLoading, dispatch
) => {
    try {
        const body = await protectedFetchReq(
            'admin/cart/abandoned-list', filters, 'POST', dispatch
        );
        if (body) {
            const { status, msg, resp } = body;
            if (status) {
                setCart(resp.shopping_carts);
                setPagination(resp.pagination);
            } else {
                if (msg === 'server-err')
                    swalMsg('error', 'Carrito abandonado',
                    'Incidente al cargar la lista');
                else if (msg === 'invalid-date-range')
                    swalMsg('warning', 'Carrito abandonado',
                    'El rango de fechas no es válido');
            }
        }
        setLoading(false);
    } catch (err) {
        setLoading(false);
        swalMsg('error', 'Carrito abandonado',
        'No se puede mostrar la lista');
    };
};

export const abandonedCartDetail = async (id, dispatch) => {
    try {
        const body = await protectedFetchReq(
            `admin/cart/abandoned-list/${id}`, {}, 'GET', dispatch
        );
        if (body && body.status)
            return body.resp.shopping_cart;
        if (body)
            swalMsg('error', 'Carrito abandonado',
            'No se pudo cargar el detalle del carrito');
        return null;
    } catch (err) {
        swalMsg('error', 'Carrito abandonado',
        'No se pudo cargar el detalle del carrito');
        return null;
    };
};
